/* components/MobileMenu.ts
Site Mobile Menu

Example
<mobile-menu>
    Site header content here
</mobile-menu>
*/

import { Component, Ref, Prop } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { cart } from "@/theme/Cart";

@Component
export class MobileMenu extends ThemeComponent {

    @Ref({required: false}) cartTrigger!: HTMLDivElement;
    @Ref() cartCount!: HTMLSpanElement;

    constructor() {
        super();
    }

    init() {
        this.$subscribe(cart.onChange, () => {
            if (cart.itemCount <= 0) {
                this.cartCount.classList.remove('active');
            } else {
                this.cartCount.classList.add('active');
            }
            this.cartCount.textContent = cart.itemCount.toString();
        });

        cart.itemsWithDisplayQuantities.map((row) => {

            row.item;
            row.displayQuantity;

        });

        this.cartEvent();
    }


    /**
     * Cart Close click event.
     * @returns
     */
    cartEvent() {
        if (this.cartTrigger) {
            this.$listen(this.cartTrigger, 'click', (event) => {
                event.preventDefault();
                document.dispatchEvent(new Event('cartOpen'));
            });
        }
    }

    cartUpdated() {
        if (cart.items.length <= 0) {
            this.cartCount.classList.add('hidden');
            return;
        }
        this.cartCount.classList.remove('hidden');
        this.cartCount.innerHTML = String(cart.items.length);
    }
}
